export const guessTimeZone = (): string => {
	try {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	} catch {
		return 'Etc/UTC';
	}
};
